import { RootState } from 'reducers';

export const selector = (state: RootState) => ({
  visible: state.sharedComponents.modalContainer.visible || state.components.modalContainer.visible,
});
